import { useValidations } from "@sttedra_ui/framework";
import { searchValue } from "@/composables/_commons/helper.js";

import { dataSourcesDatabaseTypes } from "@/api/data-sources/data-sources.api.js";

const { required, integer, minValue } = useValidations();

let ddbbTypes;

// Get the data for the dropdowns
async function databaseTypes() {
  ddbbTypes = await dataSourcesDatabaseTypes();
}

export { databaseTypes, ddbbTypes };

export default function (object = null, passwordRules) {
  return {
    items: [
      {
        field: "titulo",
        label: "Título",
        value: searchValue(object, "titulo"),
        rules: { required },
        classObj: ["col-12 md:col-8"],
      },
      {
        field: "idBbdd",
        label: "Tipo",
        value: searchValue(object, "idBbdd"),
        rules: { required },
        classObj: ["col-12 md:col-4"],
        type: "Dropdown",
        properties: {
          options: ddbbTypes,
          optionValue: "idBbdd",
          optionLabel: "tipo",
        },
      },
      {
        field: "nombreBbdd",
        label: "Base de datos",
        value: searchValue(object, "nombreBbdd"),
        rules: { required },
        classObj: ["col-12 md:col-4"],
      },
      {
        field: "host",
        label: "Host",
        value: searchValue(object, "host"),
        rules: { required },
        classObj: ["col-12 md:col-4"],
      },
      {
        field: "puerto",
        label: "Puerto",
        value: searchValue(object, "puerto"),
        rules: { required, integer, minValue: minValue(1) },
        classObj: ["col-12 md:col-4"],
      },
      {
        field: "usuario",
        label: "Usuario",
        value: searchValue(object, "usuario"),
        rules: { required },
        classObj: ["col-12 md:col-4"],
      },
      {
        field: "contrasena",
        label: "Contraseña",
        value: searchValue(object, "contrasena"),
        rules: passwordRules,
        type: "password",
        classObj: ["col-12 md:col-4"],
        properties: {
          toggleMask: true,
        },
      },
      {
        field: "descripcion",
        label: "Descripción",
        value: searchValue(object, "descripcion"),
        rules: { required },
        type: "textarea",
        classObj: ["col-12"],
      },
      {
        field: "bbddActiva",
        label: "Activo",
        value: searchValue(object, "bbddActiva"),
        type: "inputswitch",
        properties: {
          trueValue: true,
          falseValue: false,
        },
        classObj: ["col-12"],
      },
    ],
  };
}
